// Screen `home` — design/screens/Home.dc.html — owner: S2 (src/features/home).
import { createFileRoute } from '@tanstack/react-router';
import { HomePage } from '../../features/home/HomePage';

export const Route = createFileRoute('/_app/')({
  component: HomePage,
});
